import type { Profile } from '$lib/types'

export const profileColors: { [key in Profile['color']]: string } = {
  blue: 'var(--color-bg-profileblue)',
  green: 'var(--color-bg-profilegreen)',
  yellow: 'var(--color-bg-profileyellow)',
  red: 'var(--color-bg-profilered)',
  purple: 'var(--color-bg-profilepurple)',
  gray: 'var(--color-bg-profilegray)',
}

// sRGB equivalents of the light-mode profile tints (the oklch light stops in
// colors.css). Used for canvas/meta rendering (OG images), which is always
// light. Keep in sync if the light values change.
export const CONCRETE_PROFILE_COLORS = {
  blue: '#cfedff',
  green: '#d0f2dd',
  yellow: '#f9ecb6',
  red: '#ffdcd7',
  purple: '#f2e0fe',
  gray: '#e8ebef',
}
